import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    language: "English",
    fontsize: 'medium',
    authContent: null,
    dashboardContent: null,
    fundsContent: null,
    corpKycContent: null,
    corpAOContent: null,
    configurationSettingsData: null,
    user: null,
    lastLogin: null,
    applicationId: null,
    accountOpeningData: {},
    selectedAccountOpeningTab: 1
};

const contentSlice = createSlice({
    name: 'content',
    initialState,
    reducers: {
        setLanguage: (state, action) => {
            state.language = action.payload.language;
        },
        setFontsize: (state, action) => {
            state.fontsize = action.payload;
        },
        setContent: (state, action) => {
            state.authContent = action.payload.authContent;
            state.dashboardContent = action.payload.dashboardContent;
            state.fundsContent = action.payload.fundsContent;
            state.corpKycContent = action.payload.corpKycContent;
            state.corpAOContent = action.payload.corpAOContent
        },
        setConfigurationSettingsData: (state, action) => {
            state.configurationSettingsData = action.payload;
        },
        setUserData: (state, action) => {
            state.user = action.payload;
        },
        setLastLogin: (state, action) => {
            state.lastLogin = action.payload;
        },
        setApplicationId: (state, action) => {
            state.applicationId = action.payload;
        },
        setAccountOpening: (state, action) => {
            state.accountOpeningData = action.payload
        },
        setSelectedAccountOpeningTab: (state, action) => {
            state.selectedAccountOpeningTab = action.payload
        }
    }
})

export const { setLanguage, setContent, setFontsize, setConfigurationSettingsData, setUserData, setLastLogin, setApplicationId, setAccountOpening, setSelectedAccountOpeningTab } = contentSlice.actions;
export default contentSlice.reducer;